import { hFetch } from './hFetch';

type DeleteChecklistTaskArgs = {
  id: string;
  task_checklist_id: string;
};

export const deleteChecklistTask = async ({ id, task_checklist_id }: DeleteChecklistTaskArgs) => {
  return await hFetch({ url: `/api/task_checklists/${task_checklist_id}/checklist_tasks/${id}`, method: 'DELETE' });
};

export const updateChecklistTask = async ({ checklist_task }: { checklist_task: ChecklistTask }) => {
  return await hFetch({
    url: `/api/task_checklists/${checklist_task.task_checklist_id}/checklist_tasks/${checklist_task.id}`,
    method: 'PUT',
    payload: { checklist_task },
  });
};

type ChecklistTask = {
  id: number;
  name: string;
  assigned_to_role: string;
  assigned_to_user_id: number;
  checklist_taskable_type: string;
  order: number;
  task_checklist_id: number;
  created_at: string;
  updated_at: string;
};
